var alignment_rtlignore_default = {
  "alignLeft": "ECDsP",
  "textWrapNowrap": "mqRE6",
  "alignRight": "_6mRTG",
  "alignCenter": "k--V6",
  "sizeFullWidth": "_5g13-",
  "renderedInTable": "BeAJ5",
  "sizeOriginal": "fqIDt",
  "sizeContent": "g20hc",
  "sizeSmall": "V4CnV",
  "sizeSmallCenter": "ZjylM",
  "flex": "wsrXg",
  "LEFT": "Oky0i",
  "CENTER": "bU1s5",
  "RIGHT": "_3mW-T",
  "AUTO": "u6avX",
  "JUSTIFY": "v-4dh"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
